import React, { Component } from 'react';
import GetTimer from './getTimer';
import GetTimerAgente from './getTimerAgente';
import GetMusic from './getMusic';
import GetNuevaOrden from './getNuevaOrden';
import GetCambiarEstado from './getCambiarEstado';
import GetConfiguracionGlobal from './getConfiguracionGlobal';
import GetConfiguracionSucursal from './getConfiguracionSucursal';
import GetVistaSucursalUbicacion from './getVistaSucursalUbicacion';
import GetRubros from './getRubros';
import GetProductos from './getProductos';
import GetProductosActivos from './getProductosActivos';
import GetPreferencias from './getPreferencias';
import GetNewPedido from './getNewPedido';
import GetLocalesActivos from './getLocalesActivos';
import GetVistaPrevia from './getVistaPrevia';
import GetReportes from './getReportes';
import GetNewMotorizado from './getNewMotorizado';
import GetAdicionales from './getAdicionales';
import { confirmAlert } from 'react-confirm-alert';
/*
1, 'ADMINISTRADOR'
2, 'SUCURSAL'
3, 'MOTORIZADO'
4, 'CALL CENTER'
*/
import '../css_generales/getDashboard.css';
const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0,0,0,0.55)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 99999
  },
  modal: {
    width: '420px',
    background: '#fff',
    borderRadius: '10px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    overflow: 'hidden',
    animation: 'fadeIn 0.3s ease'
  },
  header: {
    background: '#d9534f',
    color: '#fff',
    padding: '14px 20px',
    fontSize: '17px',
    fontWeight: '600'
  },
  body: {
    padding: '20px',
    maxHeight: '300px',
    overflowY: 'auto'
  },
  text: {
    marginBottom: '12px',
    fontSize: '14px'
  },
  list: {
    paddingLeft: '10px',
    margin: 0
  },
  item: {
    fontSize: '14px',
    marginBottom: '6px'
  },
  footer: {
    padding: '15px',
    textAlign: 'right',
    borderTop: '1px solid #eee'
  },
  button: {
    background: '#d9534f',
    color: '#fff',
    border: 'none',
    padding: '8px 18px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: '600'
  }
};
class getDashboard extends Component {
  constructor(props){
    super(props)
    this.state = {
        pedidos : [] ,
        ultimo_pedido :'',
        sub_modal:'',
        id_pedido:'',
        id_tipo_permiso:this.props.id_tipo_permiso,
        apertura:0,
        detalle:'',
        sw_pestania:0,
        uuid_sucursal:this.props.uuid_sucursal,
        showPopupProductos: false,
        productosDesactivados: []
    }
  }
  abrir_call =(numero)=>{
    //console.log(numero)
    this.new_pedido(numero)
  }
  get_data_pedidos =(pedidos,apertura)=>{
    /*console.log(apertura)
    if(this.state.sub_modal==='nuevopedidomotorizado'){
      return
    }*/
    if(!apertura){
      //apertura =0
    }
    this.setState({
      pedidos,apertura
    })
  }

  get_go_to=(opcion)=>{
    if(opcion==='cerrar_session'){
      confirmAlert({
        title: 'Cerrar Sesión',
        message: '¿Desea Cerrar Sessión?',
        buttons: [
          {
            label: 'Sí',
            onClick: () => this.props.setCerrarSesion()
          },
          {
            label: 'No',
            onClick: () => this.get_opcion_no()
          }
        ]
      })
    }
    if(opcion==='cerrar_caja'){
      confirmAlert({
        title: 'Cerrar Billetera',
        message: '¿Desea Cerrar Billetera?',
        buttons: [
          {
            label: 'Sí',
            onClick: () => this.props.setCerrarCaja(this.props.token_User)

          },
          {
            label: 'No',
            onClick: () => this.get_opcion_no()
          }
        ]
      })
    }
  }
  get_opcion_no =()=>{

  }
  ver_pedido =(id_pedido,sub_modal,id_estado_pedido)=>{
    if(sub_modal==='cambiar_estado_motorizado'){
      confirmAlert({
        title: 'Asignar Motorizado',
        message: '¿Desea Asignarse al Pedido?',
        buttons: [
          {
            label: 'Sí',
            onClick: () => this.props.get_asignarse_pedido(id_pedido,this.props.token_User)
          },
          {
            label: 'No',
            onClick: () => this.get_opcion_no()
          }
        ]
      })
    }else{
      const id_tipo_permiso = this.state.id_tipo_permiso
      if(Number(id_tipo_permiso)===4&&sub_modal==='cambiar_estado'&&Number(id_estado_pedido)!=1){
        return null
      }
      this.setState({
        id_pedido,sub_modal
      })
    }
  }
  get_salir_vista_pedido =()=>{
    this.setState({
      id_pedido:0,sub_modal:''
    })
  }
  get_aceptar_pedido=(ultimo_pedido)=>{
    localStorage.timbrar=""
    localStorage.setItem(ultimo_pedido,"Aceptado")
    this.setState({
      ultimo_pedido,detalle:''
    })

    /******************************/
    const url= this.props.dir_url + "webapp/validarApp";
    const token =  this.props.token
    //var data = {username: 'example'};
    var obj = { accion:'validarapp', token, ultimo_pedido};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        //this.props.get_loading(false)
        //this.props.get_finalice_to(lat,lng,calle,Number(data[0].msg),referencia)
      }
    })
    .catch(console.log)
    //this.props.get_loading(true)
    /******************************/
    //localStorage.timbrar
    //localStorage.getItem(pedido.uuid_pedido)
  }

  /*llenar_pedidos_finalizado=()=>{
    const roundTo = require('round-to');
    const pedidos = this.state.pedidos
    return(
       <React.Fragment>
       <tbody>
        {pedidos.map((pedido , index) => (
          <React.Fragment key={index}>
          {(Number(pedido.id_estado_pedido)===7||Number(pedido.id_estado_pedido)===4)?
          <tr>
            <td>{pedido.secuencial}</td>
            <td>{pedido.sucursales}</td>
            <td>{pedido.forma}</td>
            <td>{pedido.fecha_creacion}{(pedido.observacion_pedido)?<React.Fragment><br/><font style={{"color":"red"}}>{pedido.observacion_pedido}</font></React.Fragment>:""}</td>
            <td style={{"textAlign":"right"}}>{roundTo(Number(pedido.total),2)}</td>
            <td>{pedido.cuenta}</td>
            <td onClick={ () => this.ver_pedido(pedido.uuid_pedido,'cambiar_estado')}>{pedido.estado_pedido}</td>
            <td>{pedido.nombre}</td>
            <td>{pedido.codigo}</td>
            <td onClick={ () => this.ver_pedido(pedido.uuid_pedido,'vista_previa')}  >Ver Pedido</td>
            <td onClick={ () => this.ver_pedido(pedido.uuid_pedido,'imprimir')}  >Imprimir</td>

          </tr>
          :''}
          </React.Fragment>
        ) ) }
      </tbody>
      </React.Fragment>
    )
  }*/
  edicionGlobal =()=>{
    this.setState({
      sub_modal:'configuracion_global'
    })
  }
  edicionSucursal =()=>{
    this.setState({
      sub_modal:'configuracion_sucursal'
    })
  }
  nuevopedidomotorizado =()=>{
    this.setState({
      sub_modal:'nuevopedidomotorizado'
    })
  }

  edicionRubros =()=>{
    this.setState({
      sub_modal:'configuracion_rubros'
    })
  }
  edicionPreferencias=()=>{
    this.setState({
      sub_modal:'configuracion_preferencias'
    })
  }
  irReportes=()=>{
    this.setState({
      sub_modal:'ir_reportes'
    })
  }
  edicionProductos =()=>{
    this.setState({
      sub_modal:'configuracion_productos'
    })
  }
  activacionProductos =()=>{
    this.setState({
      sub_modal:'activacion_productos'
    })
  }
  edicionPrecios=()=>{
    this.setState({
      sub_modal:'configuracion_precios'
    })
  }
  new_pedido =(numero)=>{
    localStorage.setItem("numero",numero)
    this.setState({
      sub_modal:'nuevo_pedido'
    })
  }
  localesActivos =()=>{
    this.setState({
      sub_modal:'locales_activos'
    })
  }
  vistaSucursal =()=>{
    this.setState({
      sub_modal:'vista_sucursal'
    })
  }
  llenar_pedidos_motorizado =(sw_opcion)=>{
    const pedidos = this.state.pedidos
    const id_tipo_permiso = this.state.id_tipo_permiso
    //console.log(id_tipo_permiso)
    /*if(Number(id_tipo_permiso)===3){//EXGO
      //console.log(id_tipo_permiso)
      pedidos.forEach(pedido =>{
        if(Number(pedido.id_estado_pedido)===6){
          if(localStorage.getItem(pedido.uuid_pedido)){

          }else{
            /*if(localStorage.timbrar){

            }else{
              localStorage.timbrar = pedido.uuid_pedido
              this.setState({
                detalle:'Nuevo Pedido'
              })
            }
          }
        }
      })
    }*/
    //const roundTo = require('round-to');

    return(
       <tbody>
        {pedidos.map((pedido , index) => (
          <React.Fragment key={index}>
          {(Number(pedido.id_estado_pedido)!==7&&Number(pedido.id_estado_pedido)!==4&&((Number(sw_opcion)===0&&Number(pedido.id_motorizado)>0)||(Number(sw_opcion)===1&&Number(pedido.id_motorizado)===0)))?
          <React.Fragment>
            <tr>
              <td colSpan="4" style={{"textAlign":"center","color":"red","fontSize":"18pt"}}><span className="span-tmp"><b>{pedido.nombre}</b></span></td>
            </tr>
            <tr>
              <td colSpan="4"  style={{"textAlign":"center","fontSize":"18pt"}}> <span className="span-tmp">
              {(Number(pedido.id_motorizado)>0)?
              <a href={"tel:"+pedido.codigo}> {pedido.codigo}</a>
              :
                <React.Fragment>{pedido.codigo}  </React.Fragment>}
              </span></td>
            </tr>
            <tr>
              <td style={{"fontSize":"18pt"}}><span className="span-tmp">{pedido.sucursales}</span></td>
              <td onClick={ () => this.ver_pedido(pedido.uuid_pedido,'vista_previa',pedido.id_estado_pedido)}  style={{"fontSize":"18pt"}} ><span className="span-tmp">Ver Pedido</span></td>
              <td style={{"fontSize":"18pt"}}><span className="span-tmp">{pedido.secuencial}</span></td>


              {(Number(pedido.id_motorizado)>0)?
                <td onClick={ () => this.ver_pedido(pedido.uuid_pedido,'cambiar_estado',pedido.id_estado_pedido)}  style={{"fontSize":"18pt"}}><span className="span-tmp">{pedido.estado_pedido}</span></td>
                :
                <td onClick={ () => this.ver_pedido(pedido.uuid_pedido,'cambiar_estado_motorizado',pedido.id_estado_pedido)}  style={{"fontSize":"18pt"}}><span className="span-tmp">Escoger Pedido</span></td>
              }


            </tr>
          </React.Fragment>
          :null}
          </React.Fragment>
        ) ) }
      </tbody>
    )
  }
  /*
    {this.llenar_pedidos()}
  */
  llenar_pedidos =()=>{
    //if(1===1)return
    const pedidos = this.state.pedidos
    const id_tipo_permiso = this.state.id_tipo_permiso
    //console.log(id_tipo_permiso)
    if(Number(id_tipo_permiso)===1||Number(id_tipo_permiso)===2){//EXGO
      //console.log(id_tipo_permiso)
      pedidos.forEach(pedido =>{
        if(Number(pedido.id_estado_pedido)===6){
          if(localStorage.getItem(pedido.uuid_pedido)){

          }else{
            if(localStorage.timbrar){

            }else{
              localStorage.timbrar = pedido.uuid_pedido
              //console.log("timbrar")
            }
          }
        }
      })
    }
    const roundTo = require('round-to');
    ////cast(lpad(cod_pedido,6,'0') as char) as secuencial,fecha_creacion,total,estado_pedido,uuid_pedido,nombre,codigo
    //Number(pedido.id_estado_pedido)!==7&&Number(pedido.id_estado_pedido)!==4)
    //if(Number(this.state.sw_pestania!==0)){
    ///  return null
    //}

    return(
      <table className="tb_pedidos">
        <thead>
        <tr>
          <th>Orden</th>
          <th>Sucursal</th>
          <th>Tipo</th>
          <th>Fecha Pedido</th>
          <th>Total</th>
          <th>Cuenta</th>
          <th>Estado</th>
          <th>Nombre</th>
          <th>Teléfono</th>
          <th>Opciones</th>
        </tr>
        </thead>
       <tbody>
        {(pedidos)?
          pedidos.map((pedido , index) => (
          <React.Fragment key={index}>
          {((Number(this.state.sw_pestania===0)&&Number(pedido.id_estado_pedido)!==7&&Number(pedido.id_estado_pedido)!==4&&Number(pedido.id_estado_pedido)!==5&&Number(pedido.id_estado_pedido)!==2&&Number(pedido.id_estado_pedido)!==3)||(Number(this.state.sw_pestania===1)&&Number(pedido.id_estado_pedido)===2)||(Number(this.state.sw_pestania===2)&&Number(pedido.id_estado_pedido)===7)||(Number(this.state.sw_pestania===3)&&(Number(pedido.id_estado_pedido)===4||Number(pedido.id_estado_pedido)===5)))?
          <tr className={
            (Number(pedido.minutos)>30&&Number(pedido.id_estado_pedido)===1)?
             "color_atrasado"
             :
             ""
          }>
            <td>{pedido.secuencial}</td>
            <td>{pedido.sucursales}</td>
            <td style={{"backgroundColor":(pedido.forma==='Retirar')?"yellow":""}}>{pedido.forma}</td>
            <td>{pedido.fecha_creacion}{(pedido.observacion_pedido)?<React.Fragment><br/><font style={{"color":"red"}}>{pedido.observacion_pedido}</font></React.Fragment>:""}</td>
            <td style={{"textAlign":"right"}}>{roundTo(Number(pedido.total),2)}</td>
            <td>{pedido.cuenta+" "+pedido.id_motorizado}</td>
            <td
             className={
               (Number(pedido.id_estado_pedido)===6)?
                "color_nuevo"
               :
               (Number(pedido.id_estado_pedido)===1)?
                (Number(pedido.id_motorizado)===0)?
                  "color_preparando"
                  :
                  "color_preparandoM"
                :
                (Number(pedido.id_estado_pedido)===2)?
                 ""
                :
               ""
             }
             onClick={ () => this.ver_pedido(pedido.uuid_pedido,'cambiar_estado',pedido.id_estado_pedido)}
             >{pedido.estado_pedido}</td>
            <td>{pedido.nombre}</td>
            <td>{pedido.codigo}</td>
            <td onClick={ () => this.ver_pedido(pedido.uuid_pedido,'vista_previa',pedido.id_estado_pedido)}  >Ver Pedido</td>
            <td onClick={ () => this.ver_pedido(pedido.uuid_pedido,'imprimir',pedido.id_estado_pedido)}  >Imprimir</td>
          </tr>
          :null}
          </React.Fragment>
        ) ):null }
      </tbody>
      </table>
    )
  }
  cambiar_pestania =(sw_pestania)=>{
    this.setState({sw_pestania})
  }
  imprimir =(nombre)=>{
      var ficha = document.getElementById(nombre);
  	  var ventimp = window.open(' ', 'popimpr');
  	  ventimp.document.write( ficha.innerHTML );
  	  ventimp.document.close();
  	  ventimp.print( );
  	  ventimp.close();
  }

  render() {
    //console.log("dddd__")
    const id_tipo_permiso = this.state.id_tipo_permiso
    if(Number(id_tipo_permiso)===0){
      return(
          <React.Fragment>
          </React.Fragment>
      )
    }
    let sw_1 =0;
    let sw_2 =0;
    //let sw_3 =0;
    let sw_4 =0;
    let sw_5 =0;
    let sw_6 =0;
    let sw_7 =0;

    this.state.pedidos.forEach(pedido =>{
      if(Number(pedido.id_estado_pedido)===1){
        sw_1++
      }
      if(Number(pedido.id_estado_pedido)===2){
        sw_2++
      }
      //if(Number(pedido.id_estado_pedido)===3){
      //  sw_3++
      //}
      if(Number(pedido.id_estado_pedido)===4){
        sw_4++
      }
      if(Number(pedido.id_estado_pedido)===5){
        sw_5++
      }
      if(Number(pedido.id_estado_pedido)===6){
        sw_6++
      }
      if(Number(pedido.id_estado_pedido)===7){
        sw_7++
      }
    })

    const sub_modal = this.state.sub_modal
    let sub_pantalla_modal
    if(sub_modal==='imprimir'){
      sub_pantalla_modal=<div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                          <GetVistaPrevia separator={this.props.separator} url_image={this.props.url_image}  token_pedido={this.state.id_pedido} token={this.props.token} dir_url={this.props.dir_url} get_aceptar_pedido={this.get_salir_vista_pedido} imprimir={this.imprimir}/>
                        </div>
    }
    if(sub_modal==='vista_previa'){
      sub_pantalla_modal=<div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                          <GetNuevaOrden  id_tipo_permiso={this.state.id_tipo_permiso}   separator={this.props.separator} url_image={this.props.url_image}   firebase={this.props.firebase}   file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60}  token_pedido={this.state.id_pedido} token={this.props.token} dir_url={this.props.dir_url} get_aceptar_pedido={this.get_salir_vista_pedido}/>
                        </div>
    }
    if(sub_modal==='cambiar_estado'){
      sub_pantalla_modal=<div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                            <GetCambiarEstado id_tipo_permiso={id_tipo_permiso} separator={this.props.separator} url_image={this.props.url_image}  token_pedido={this.state.id_pedido} get_loading={this.props.get_loading} get_salir_vista_pedido={this.get_salir_vista_pedido} token={this.props.token} dir_url={this.props.dir_url}/>
                          </div>
    }
    if(sub_modal==='configuracion_global'){
      sub_pantalla_modal=<div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                            <GetConfiguracionGlobal separator={this.props.separator} url_image={this.props.url_image}   firebase={this.props.firebase}   file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60}  get_loading={this.props.get_loading} get_salir_vista_pedido={this.get_salir_vista_pedido} token={this.props.token} dir_url={this.props.dir_url}/>
                          </div>
    }
    if(sub_modal==='configuracion_sucursal'){
      sub_pantalla_modal=<div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                            <GetConfiguracionSucursal separator={this.props.separator} url_image={this.props.url_image}  firebase={this.props.firebase}   file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60} id_sucursal={this.props.id_sucursal} get_loading={this.props.get_loading} get_salir_vista_pedido={this.get_salir_vista_pedido} token={this.props.token} dir_url={this.props.dir_url}/>
                          </div>
    }
    if(sub_modal==='nuevopedidomotorizado'){
      //console.log("Motorizados")
      sub_pantalla_modal=<div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                            <GetNewMotorizado uuid_sucursal={this.state.uuid_sucursal} separator={this.props.separator} url_image={this.props.url_image}  firebase={this.props.firebase}   file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60} id_sucursal={this.props.id_sucursal} get_loading={this.props.get_loading} get_salir_vista_pedido={this.get_salir_vista_pedido} token={this.props.token} dir_url={this.props.dir_url}/>
                          </div>
    }
    if(sub_modal==='vista_sucursal'){
      sub_pantalla_modal=<div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                            <GetVistaSucursalUbicacion separator={this.props.separator} url_image={this.props.url_image}  id_sucursal={this.props.id_sucursal} get_salir_vista_pedido={this.get_salir_vista_pedido} token={this.props.token} dir_url={this.props.dir_url}/>
                          </div>
    }
    if(sub_modal==='configuracion_preferencias'){
      sub_pantalla_modal=<div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                            <GetPreferencias separator={this.props.separator} url_image={this.props.url_image}    firebase={this.props.firebase}   file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60} get_loading={this.props.get_loading}   get_salir_vista_pedido={this.get_salir_vista_pedido} token={this.props.token} dir_url={this.props.dir_url}/>
                          </div>
    }
    if(sub_modal==='ir_reportes'){
      sub_pantalla_modal=<div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                            <GetReportes id_sucursal={this.props.id_sucursal} id_tipo_permiso={this.state.id_tipo_permiso} separator={this.props.separator} url_image={this.props.url_image}    firebase={this.props.firebase}   file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60} get_loading={this.props.get_loading}   get_salir_vista_pedido={this.get_salir_vista_pedido} token={this.props.token} dir_url={this.props.dir_url}/>
                          </div>
    }

    if(sub_modal==='configuracion_rubros'){
      sub_pantalla_modal=<div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                            <GetRubros separator={this.props.separator} url_image={this.props.url_image}    firebase={this.props.firebase}   file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60} get_loading={this.props.get_loading}   get_salir_vista_pedido={this.get_salir_vista_pedido} token={this.props.token} dir_url={this.props.dir_url}/>
                          </div>
    }
    if(sub_modal==='configuracion_productos'){
      sub_pantalla_modal=<div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                            <GetProductos separator={this.props.separator} url_image={this.props.url_image}   firebase={this.props.firebase}   file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_250x250={this.props.file_250x250} file_60x60={this.props.file_60x60} get_loading={this.props.get_loading}   get_salir_vista_pedido={this.get_salir_vista_pedido} token={this.props.token} dir_url={this.props.dir_url}/>
                          </div>
    }
    if(sub_modal==='activacion_productos'){
      sub_pantalla_modal=<div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                          <GetProductosActivos  id_sucursal={this.props.id_sucursal} separator={this.props.separator} url_image={this.props.url_image}   firebase={this.props.firebase}   file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_250x250={this.props.file_250x250} file_60x60={this.props.file_60x60} get_loading={this.props.get_loading}   get_salir_vista_pedido={this.get_salir_vista_pedido} token={this.props.token} dir_url={this.props.dir_url}/>
                        </div>
    }
    if(sub_modal==='configuracion_precios'){
      sub_pantalla_modal=<div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                            <GetAdicionales separator={this.props.separator} url_image={this.props.url_image}   firebase={this.props.firebase}   file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_250x250={this.props.file_250x250} file_60x60={this.props.file_60x60} get_loading={this.props.get_loading}   get_salir_vista_pedido={this.get_salir_vista_pedido} token={this.props.token} dir_url={this.props.dir_url}/>
                          </div>
    }

    if(sub_modal==='nuevo_pedido'){
      sub_pantalla_modal=<div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                            <GetNewPedido database={this.props.database} uuid_agente={this.props.uuid_agente}  usuario={this.props.usuario} separator={this.props.separator} url_image={this.props.url_image}   firebase={this.props.firebase}   file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60} get_loading={this.props.get_loading}   get_salir_vista_pedido={this.get_salir_vista_pedido} token={this.props.token} dir_url={this.props.dir_url}/>
                          </div>
    }
    if(sub_modal==='locales_activos'){
      sub_pantalla_modal=<div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                            <GetLocalesActivos  usuario={this.props.usuario} separator={this.props.separator} url_image={this.props.url_image}   firebase={this.props.firebase}   file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60} get_loading={this.props.get_loading}   get_salir_vista_pedido={this.get_salir_vista_pedido} token={this.props.token} dir_url={this.props.dir_url}/>
                          </div>
    }
    const roundTo = require('round-to');
    const pedido = this.state.pedidos
    let total_precio = 0
    pedido.forEach (item => {
      if(Number(item.id_estado_pedido)===7||Number(item.id_estado_pedido)===2||Number(item.id_estado_pedido)===3||Number(item.id_estado_pedido)===1){
        total_precio = roundTo(total_precio + Number(item.total),2)
      }
    })

    /*<!--<div className="cssversion_pw30 cssversion_contentCenter">
       {total_precio}<img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/money.gif') }  />
    </div>-->*/

    let current_datetime = new Date()
    let formatted_date = current_datetime.getFullYear() + "-" + (current_datetime.getMonth() + 1).toString().padStart(2,"0") + "-" +
    current_datetime.getDate().toString().padStart(2,"0") + " " + current_datetime.getHours().toString().padStart(2,"0") + ":" + current_datetime.getMinutes().toString().padStart(2,"0")
    let modal
    //console.log(this.props.token_User+'ssssaa')
    if(Number(id_tipo_permiso)===5){
      modal=<React.Fragment>
      <div className="cssversion_menu cssversion_colorwhite" style={{"color":"black"}}>
        <div className="cssversion_pw100 cssversion_ph100" style={{"display":"flex"}}>
          <div className="cssversion_pw20 cssversion_ph100 cssversion_inlinetable" >
            <div className="cssversion_pw100 cssversion_ph100" style={{"overflowY":"auto"}}>
              <div  className="cssversion_pw100 cssversion_pxh60 cssversion_div_option" style={{"display":"flex"}}>
                <div  className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter">
                    <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/1388560951582004484-128.png') } />
                </div>
                <div  className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">
                    {this.props.usuario}
                </div>
              </div>
              <div  className="cssversion_pw100 cssversion_pxh60 cssversion_div_option" style={{"display":"flex"}} onClick={ () => this.irReportes()}>
                <div  className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter">
                    <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
                </div>
                <div  className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">
                    Reportes
                </div>
              </div>
              <div className="cssversion_pw100 cssversion_pxh90" style={{"display":"flex"}}>
                <div className="cssversion_pw100 cssversion_pxh90 cssversion_contentCenter">
                  <button className="button-global cssversion_pw85" onClick={ () => this.props.setCerrarSesion()}>
                    Cerrar Sesión
                  </button>
                </div>
              </div>
            </div>
        {sub_pantalla_modal}
        </div>
      </div>
    </div>
      </React.Fragment>
    }else if(Number(id_tipo_permiso)===9){
      modal=<React.Fragment>
        <div className="grid-container-global_usuario">
          <div className="lbl_opcion_1">
            <div className="grid-container-user-opcion">
              <div className="lbl_foto_opcion"><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/1388560951582004484-128.png') } /></div>
              <div className="lbl_label_opcion">{this.props.usuario}</div>
            </div>
          </div>
          <div className="lbl_opcion_2">
            <div className="grid-container-user-opcion" onClick={ () => this.edicionRubros()} >
              <div className="lbl_foto_opcion"><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } /></div>
              <div className="lbl_label_opcion">Edición Rubros</div>
            </div>
          </div>
          <div className="lbl_final" >
            <div className="grid-container-user-opcion" onClick={ () => this.props.setCerrarSesion()}>
              <div className="lbl_foto_opcion"><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/20635100751582004491-128.png') } /></div>
              <div className="lbl_label_opcion">Cerrar Sesión</div>
            </div>
          </div>
        </div>
        {sub_pantalla_modal}
      </React.Fragment>
    }else{
      if(Number(id_tipo_permiso)===3){

        if(Number(this.state.apertura)===0){
          modal=<React.Fragment>
          <div className="cssversion_menu cssversion_colorblanco">
            <div className="cssversion_pw100 cssversion_pxh90" style={{"display":"flex"}}>
              <div className="cssversion_pw100 cssversion_pxh90 cssversion_contentCenter">
                <img className="cssversion_pxw50 cssversion_colorprimario" alt="Cargando Imagen . . ." src={ require('../image/3581574551582004499-128.png') } />
              </div>
            </div>
            <div className="cssversion_pw100 cssversion_pxh90" style={{"display":"flex"}}>
              <div className="cssversion_pw100 cssversion_pxh90 cssversion_contentCenter">
                <button className="button-global cssversion_pw85" onClick={ () => this.props.setAbrirCaja(this.props.token_User)}>
                  Abrir Billetera
                </button>
              </div>
            </div>
            <div className="cssversion_pw100 cssversion_pxh90" style={{"display":"flex"}}>
              <div className="cssversion_pw100 cssversion_pxh90 cssversion_contentCenter">
                <img className="cssversion_pxw50 cssversion_colorprimario" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } />
              </div>
            </div>
            <div className="cssversion_pw100 cssversion_pxh90" style={{"display":"flex"}}>
              <div className="cssversion_pw100 cssversion_pxh90 cssversion_contentCenter">
                <button className="button-global cssversion_pw85" onClick={ () => this.props.setCerrarSesion()}>
                  Cerrar Sesión
                </button>
              </div>
            </div>
          </div>
          <GetTimer id_tipo_permiso={this.state.id_tipo_permiso} get_data_pedidos={this.get_data_pedidos} sucursal={this.props.sucursal} usuario={this.props.usuario} id_sucursal={this.props.id_sucursal} get_loading={this.get_loading} setTokenusuario={this.setTokenusuario} token={this.props.token} dir_url={this.props.dir_url} token_User={this.props.token_User}/>
          </React.Fragment>
        }else{
          modal=<React.Fragment>
          <div className="cssversion_menu cssversion_colorblanco">
            <div className="cssversion_pw100 ">
              <div className="cssversion_pw100 cssversion_contentCenter"  style={{"display":"flex"}}>
                <span className="span-global-title-producto">{"Pedidos Preparando y Enviando"}</span>
             </div>
              <div className="cssversion_pw100" style={{"display":"flex"}}>
                <table className="tb_pedidos">
                  <thead>
                  <tr>
                    <th style={{"fontSize":"18pt"}}><span className="span-tmp">Local</span></th>
                    <th style={{"fontSize":"18pt"}}><span className="span-tmp">Opciones</span></th>
                    <th style={{"fontSize":"18pt"}}><span className="span-tmp">Orden</span></th>
                    <th style={{"fontSize":"18pt"}}><span className="span-tmp">Estado</span></th>
                  </tr>
                  </thead>
                  {this.llenar_pedidos_motorizado(0)}
                </table>
                 </div>
                <div className="cssversion_pw100 cssversion_contentCenter" style={{"display":"flex"}}>
                  <span className="span-global-title-producto">{"Pedidos No Asignado Motorizado"}</span>
                </div>
                <div className="cssversion_pw100" style={{"display":"flex"}}>
                <table className="tb_pedidos">
                  <thead>
                  <tr>
                    <th style={{"fontSize":"18pt"}}><span className="span-tmp">Local</span></th>
                    <th style={{"fontSize":"18pt"}}><span className="span-tmp">Opciones</span></th>
                    <th style={{"fontSize":"18pt"}}><span className="span-tmp">Orden</span></th>
                    <th style={{"fontSize":"18pt"}}><span className="span-tmp">Estado</span></th>
                  </tr>
                  </thead>
                  {this.llenar_pedidos_motorizado(1)}
                </table>
              </div>
            </div>
            <div className="cssversion_pw100 cssversion_pxh90" style={{"display":"flex"}}>
              <div className="cssversion_pw100 cssversion_pxh90 cssversion_contentCenter">
                <img className="cssversion_pxw50 cssversion_colorprimario" alt="Cargando Imagen . . ." src={ require('../image/3581574551582004499-128.png') } />
              </div>
            </div>
            <div className="cssversion_pw100 cssversion_pxh90" style={{"display":"flex"}}>
              <div className="cssversion_pw100 cssversion_pxh90 cssversion_contentCenter">
                <button className="button-global cssversion_pw85" onClick={ () => this.get_go_to('cerrar_caja')}>
                  Cerrar Billetera
                </button>
              </div>
            </div>
            <div className="cssversion_pw100 cssversion_pxh90" style={{"display":"flex"}}>
              <div className="cssversion_pw100 cssversion_pxh90 cssversion_contentCenter">
                <img className="cssversion_pxw50 cssversion_colorprimario" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } />
              </div>
            </div>
            <div className="cssversion_pw100 cssversion_pxh90" style={{"display":"flex"}}>
              <div className="cssversion_pw100 cssversion_pxh90 cssversion_contentCenter">
                <button className="button-global cssversion_pw85" onClick={ () => this.get_go_to('cerrar_session')}>
                  Cerrar Sesión
                </button>
              </div>
            </div>
          </div>


          <GetTimer id_tipo_permiso={this.state.id_tipo_permiso} get_data_pedidos={this.get_data_pedidos} sucursal={this.props.sucursal} usuario={this.props.usuario} id_sucursal={this.props.id_sucursal} get_loading={this.get_loading} setTokenusuario={this.setTokenusuario} token={this.props.token} dir_url={this.props.dir_url} token_User={this.props.token_User}/>
          {(localStorage.timbrar)?
            <React.Fragment>
              <div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                <GetNuevaOrden id_tipo_permiso={this.state.id_tipo_permiso}  separator={this.props.separator} url_image={this.props.url_image}   firebase={this.props.firebase}   file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60} token_pedido={localStorage.timbrar} token={this.props.token} dir_url={this.props.dir_url} get_aceptar_pedido={this.get_aceptar_pedido}/>
              </div>
              {(window.Android) ?
                window.Android.showToast(this.state.detalle)
              :<GetMusic/>}
            </React.Fragment>
          :
            sub_pantalla_modal
          }
          </React.Fragment>
        }



      }else{






        modal=
        <React.Fragment>
          <div className="cssversion_menu cssversion_colorwhite" style={{"color":"black"}}>
            <div className="cssversion_pw100 cssversion_ph100" style={{"display":"flex"}}>
              <div className="cssversion_pw20 cssversion_ph100 cssversion_inlinetable" >
                <div className="cssversion_pw100 cssversion_ph100" style={{"overflowY":"auto"}}>
                  <div  className="cssversion_pw100 cssversion_pxh60 cssversion_div_option" style={{"display":"flex"}}>
                    <div  className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter">
                        <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/1388560951582004484-128.png') } />
                    </div>
                    <div  className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">
                        {this.props.usuario}
                    </div>
                  </div>
                  {Number(id_tipo_permiso)===1?
                  <div  className="cssversion_pw100 cssversion_pxh60 cssversion_div_option" style={{"display":"flex"}} onClick={ () => this.edicionGlobal()}>
                    <div  className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter">
                        <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
                    </div>
                    <div  className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">
                        Edición Global
                    </div>
                  </div>
                  :null}
                  {Number(id_tipo_permiso)===4?
                  <div  className="cssversion_pw100 cssversion_pxh60 cssversion_div_option" style={{"display":"flex"}} onClick={ () => this.new_pedido('')}>
                    <div  className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter">
                        <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
                    </div>
                    <div  className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">
                        Nuevo Pedido
                    </div>
                  </div>
                  :null}
                  {Number(id_tipo_permiso)===4?
                  <div  className="cssversion_pw100 cssversion_pxh60 cssversion_div_option" style={{"display":"flex"}} onClick={ () => this.localesActivos('')}>
                    <div  className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter">
                        <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
                    </div>
                    <div  className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">
                        Locales Activos
                    </div>
                  </div>
                  :null}
                  {Number(id_tipo_permiso)===1?
                  <div  className="cssversion_pw100 cssversion_pxh60 cssversion_div_option" style={{"display":"flex"}} onClick={ () => this.edicionSucursal()}>
                    <div  className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter">
                        <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
                    </div>
                    <div  className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">
                        Edición Sucursal
                    </div>
                  </div>
                  :null}
                  {Number(id_tipo_permiso)===1?
                  <div  className="cssversion_pw100 cssversion_pxh60 cssversion_div_option" style={{"display":"flex"}} onClick={ () => this.nuevopedidomotorizado()}>
                    <div  className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter">
                        <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
                    </div>
                    <div  className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">
                        Pedir Motorizado
                    </div>
                  </div>
                  :null}
                  {(Number(id_tipo_permiso)===4||Number(id_tipo_permiso)===2)?
                  <div  className="cssversion_pw100 cssversion_pxh60 cssversion_div_option" style={{"display":"flex"}} onClick={ () => this.irReportes()}>
                    <div  className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter">
                        <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
                    </div>
                    <div  className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">
                        Reportes
                    </div>
                  </div>
                  :null}
                  {Number(id_tipo_permiso)===1?
                  <div  className="cssversion_pw100 cssversion_pxh60 cssversion_div_option" style={{"display":"flex"}} onClick={ () => this.edicionPreferencias()}>
                    <div  className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter">
                        <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
                    </div>
                    <div  className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">
                        Preferencias
                    </div>
                  </div>
                  :null}
                  {Number(id_tipo_permiso)===1?
                  <div  className="cssversion_pw100 cssversion_pxh60 cssversion_div_option" style={{"display":"flex"}} onClick={ () => this.edicionRubros()}>
                    <div  className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter">
                        <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
                    </div>
                    <div  className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">
                        Edición Rubros
                    </div>
                  </div>
                  :null}
                  {Number(id_tipo_permiso)===1?
                  <div  className="cssversion_pw100 cssversion_pxh60 cssversion_div_option" style={{"display":"flex"}} onClick={ () => this.edicionProductos()}>
                    <div  className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter">
                        <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
                    </div>
                    <div  className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">
                        Edición Productos
                    </div>
                  </div>
                  :null}
                   {Number(id_tipo_permiso)===2?
                  <div  className="cssversion_pw100 cssversion_pxh60 cssversion_div_option" style={{"display":"flex"}} onClick={ () => this.activacionProductos()}>
                    <div  className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter">
                        <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
                    </div>
                    <div  className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">
                        Activación de Productos
                    </div>
                  </div>
                  :null}
                  {Number(id_tipo_permiso)===1?
                  <div  className="cssversion_pw100 cssversion_pxh60 cssversion_div_option" style={{"display":"flex"}} onClick={ () => this.edicionPrecios()}>
                    <div  className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter">
                        <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
                    </div>
                    <div  className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">
                        Edición Precios Lote
                    </div>
                  </div>
                  :null}
                  {(Number(id_tipo_permiso)===1||Number(id_tipo_permiso)===2)?
                  <div  className="cssversion_pw100 cssversion_pxh60 cssversion_div_option" style={{"display":"flex"}} onClick={ () => this.vistaSucursal()}>
                    <div  className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter">
                        <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
                    </div>
                    <div  className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">
                        Vista Ubicación
                    </div>
                  </div>
                  :null}
                  <div  className="cssversion_pw100 cssversion_pxh60 cssversion_div_option" style={{"display":"flex"}} onClick={ () => this.props.setCerrarSesion()}>
                    <div  className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter">
                        <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/20635100751582004491-128.png') } />
                    </div>
                    <div  className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">
                        Cerrar Sesión
                    </div>
                  </div>
                </div>
              </div>
              <div className="cssversion_pw80 cssversion_ph100">
                <div className="cssversion_pw100 cssversion_ph10" style={{"display":"flex"}}>
                  {(this.props.sucursal)?
                  <div  className="cssversion_pw30 cssversion_ph100 cssversion_textCenter">
                    Establecimiento:<br/>
                    <span className="span-global-title-producto">{this.props.sucursal}</span>
                  </div>:null}
                  {(this.props.agente_nombre)?
                  <div  className="cssversion_pw30 cssversion_ph100 cssversion_textCenter">
                    Agente:<br/>
                    <span className="span-global-title-producto">{this.props.agente_nombre}</span>
                  </div>:null}
                   <div  className="cssversion_pw30 cssversion_ph100 cssversion_textCenter">
                     Fecha y Hora Actual: <br/><span style={{"color":"red","fontSize":"19pt"}}>{formatted_date}</span><br/>
                    </div>
                    <div  className="cssversion_pw30 cssversion_ph100 cssversion_textCenter">
                      Horario de Atención:<br/>
                      <span className="span-global-title-producto">{this.props.hora_apertura} -  {this.props.hora_cierre}</span>
                      </div>
                </div>

                <div className="cssversion_pw100 cssversion_ph90" style={{"display":"flex"}}>
                  <div className="cssversion_pw100 cssversion_ph100 cssversion_inlinetable">
                    <div className="cssversion_pw100 cssversion_ph10" style={{"display":"flex"}}>
                      <div  onClick={ () => this.cambiar_pestania(0)} className={(Number(this.state.sw_pestania)===0)?"cssversion_pw25 cssversion_ph100 cssversion_contentCenter cssversion_div_pestania_activa":"cssversion_pw25 cssversion_ph100 cssversion_contentCenter cssversion_div_pestania_activa_disabled"}>
                        <span className="span-sin-formato">Por Confirmar({sw_6}) <br/>Preparando ({sw_1})</span>
                      </div>
                      <div  onClick={ () => this.cambiar_pestania(1)} className={(Number(this.state.sw_pestania)===1)?"cssversion_pw25 cssversion_ph100 cssversion_contentCenter cssversion_div_pestania_activa":"cssversion_pw25 cssversion_ph100 cssversion_contentCenter cssversion_div_pestania_activa_disabled"}>
                        <span className="span-sin-formato">Enviando a Cliente ({sw_2})</span>
                      </div>
                      <div onClick={ () => this.cambiar_pestania(2)} className={(Number(this.state.sw_pestania)===2)?"cssversion_pw25 cssversion_ph100 cssversion_contentCenter cssversion_div_pestania_activa":"cssversion_pw25 cssversion_ph100 cssversion_contentCenter cssversion_div_pestania_activa_disabled"}>
                        <span className="span-sin-formato">Finalizados ({sw_7})</span>
                      </div>
                      <div onClick={ () => this.cambiar_pestania(3)} className={(Number(this.state.sw_pestania)===3)?"cssversion_pw25 cssversion_ph100 cssversion_contentCenter cssversion_div_pestania_activa":"cssversion_pw25 cssversion_ph100 cssversion_contentCenter cssversion_div_pestania_activa_disabled"}>
                        <span className="span-sin-formato">Cancelados ({sw_4+sw_5})</span>
                      </div>
                    </div>
                    <div className="cssversion_pw100 cssversion_ph90" style={{"overflowY":"auto"}}>
                    {this.llenar_pedidos()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <React.Fragment>
          <GetTimerAgente id_tipo_permiso={this.state.id_tipo_permiso} abrir_call={this.abrir_call} usuario={this.props.usuario} token={this.props.token} dir_url={this.props.dir_url} />
                
          {(sub_modal==='')?
              <React.Fragment>
                <GetTimer id_tipo_permiso={this.state.id_tipo_permiso} get_data_pedidos={this.get_data_pedidos} sucursal={this.props.sucursal} usuario={this.props.usuario} id_sucursal={this.props.id_sucursal} get_loading={this.get_loading} setTokenusuario={this.setTokenusuario} token={this.props.token} dir_url={this.props.dir_url} token_User={this.props.token_User}/>
                
                {(localStorage.timbrar)?
                  <React.Fragment>
                    <div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                      <GetNuevaOrden  id_tipo_permiso={this.state.id_tipo_permiso} separator={this.props.separator} url_image={this.props.url_image}   firebase={this.props.firebase}   file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60} token_pedido={localStorage.timbrar} token={this.props.token} dir_url={this.props.dir_url} get_aceptar_pedido={this.get_aceptar_pedido}/>
                    </div>
                    <GetMusic/>
                  </React.Fragment>
                :
                  sub_pantalla_modal
                }
              </React.Fragment>
          :sub_pantalla_modal}
          </React.Fragment>
        </React.Fragment>



      }
    }

    const popupProductosDesactivados = this.state.showPopupProductos ? (
      <div style={styles.overlay}>
        <div style={styles.modal}>
          <div style={styles.header}>
            ⚠️ Productos desactivados
          </div>

          <div style={styles.body}>
            <p style={styles.text}>
              Los siguientes productos están <b>desactivados en esta sucursal</b>:
            </p>

            <ul style={styles.list}>
              {this.state.productosDesactivados.map((p, i) => (
                <li key={i} style={styles.item}>• {p.producto}</li>
              ))}
            </ul>
          </div>

          <div style={styles.footer}>
            <button
              style={styles.button}
              onClick={() => this.setState({ showPopupProductos: false })}
            >
              Entendido
            </button>
          </div>
        </div>
      </div>
    ) : null;
    return(
      <React.Fragment>
      {modal}
      {popupProductosDesactivados}
      </React.Fragment>
    )
  }
  verificarProductosDesactivados = () => {
    if(Number(this.state.id_tipo_permiso)!==2)return null
    const url = this.props.dir_url + "webapp/getProductoActivoSucursal";
    const token = this.props.token;
    const id_sucursal = this.props.id_sucursal;

    const obj = {
      accion: 'productoactivo',
      token,
      id_sucursal
    };

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then(data => {
      if (
        data &&
        data[0] &&
        data[0].status === "ok" &&
        data[0].msg &&
        data[0].msg.length > 0
      ) {
        this.setState({
          showPopupProductos: true,
          productosDesactivados: data[0].msg
        });
      }
    })
    .catch(console.error);
  }
  componentDidMount (){
    // Reproducir audio silencioso
    if (!window.audioSilencioso) {
      window.audioSilencioso = new Audio("data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAESsAACJWAAACABAAZGF0YQAAAAA=");
      window.audioSilencioso.volume = 0.01;
    }

    // Reproducir cada 2 minutos
    if (!window.audioInterval) {
      window.audioInterval = setInterval(() => {
        window.audioSilencioso.currentTime = 0;
        window.audioSilencioso.play()
          .then(() => console.log("🔊 Sonido reproducido (cada 2 min)"))
          .catch(console.warn);
      }, 2 * 60 * 1000); // 2 minutos
    }
    this.verificarProductosDesactivados();
  }
}
export default getDashboard;/*<div className="grid-container-global_usuario">
  <div className="lbl_opcion_1">
    <div className="grid-container-user-opcion">
      <div className="lbl_foto_opcion"><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/1388560951582004484-128.png') } /></div>
      <div className="lbl_label_opcion">{this.props.usuario}</div>
    </div>
  </div>
  <div className="lbl_opcion_2" >
    {(Number(id_tipo_permiso)===1)?
    <div className="grid-container-user-opcion" onClick={ () => this.edicionGlobal()}>
      <div className="lbl_foto_opcion"><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } /></div>
      <div className="lbl_label_opcion">Edición Global</div>
    </div>
    :''}
    {(Number(id_tipo_permiso)===4)?
    <div className="grid-container-user-opcion" onClick={ () => this.new_pedido()} >
      <div className="lbl_foto_opcion"><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } /></div>
      <div className="lbl_label_opcion">Nuevo Pedido</div>
    </div>
    :''}
  </div>
  <div className="lbl_opcion_3">
    {(Number(id_tipo_permiso)===1)?
    <div className="grid-container-user-opcion" onClick={ () => this.edicionSucursal()} >
      <div className="lbl_foto_opcion"><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } /></div>
      <div className="lbl_label_opcion">Edición Sucursal</div>
    </div>
    :''}
    {(Number(id_tipo_permiso)===4)?
    <div className="grid-container-user-opcion">
      <div className="lbl_foto_opcion"><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } /></div>
      <div className="lbl_label_opcion">Reportes</div>
    </div>
    :''}
  </div>
  <div className="lbl_opcion_4">
    {(Number(id_tipo_permiso)===1)?
    <div className="grid-container-user-opcion" onClick={ () => this.edicionPreferencias()} >
      <div className="lbl_foto_opcion"><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } /></div>
      <div className="lbl_label_opcion">Edición Preferencias</div>
    </div>
    :''}
  </div>
  <div className="lbl_opcion_5">
    {(Number(id_tipo_permiso)===1)?
    <div className="grid-container-user-opcion" onClick={ () => this.edicionRubros()} >
      <div className="lbl_foto_opcion"><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } /></div>
      <div className="lbl_label_opcion">Edición Rubros</div>
    </div>
    :''}
  </div>
  <div className="lbl_opcion_6">
    {(Number(id_tipo_permiso)===1)?
    <div className="grid-container-user-opcion" onClick={ () => this.edicionProductos()} >
      <div className="lbl_foto_opcion"><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } /></div>
      <div className="lbl_label_opcion">Edición Productos</div>
    </div>
    :''}
  </div>
  <div className="lbl_opcion_7">
    {(Number(id_tipo_permiso)===1)?
    <div className="grid-container-user-opcion" onClick={ () => this.vistaSucursal()} >
      <div className="lbl_foto_opcion"><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } /></div>
      <div className="lbl_label_opcion">Vista Ubicación</div>
    </div>
    :''}
  </div>
  <div className="lbl_opcion_8">

  </div>
  <div className="lbl_final" >
    <div className="grid-container-user-opcion" onClick={ () => this.props.setCerrarSesion()}>
      <div className="lbl_foto_opcion"><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/20635100751582004491-128.png') } /></div>
      <div className="lbl_label_opcion">Cerrar Sesión</div>
    </div>
  </div>
*/
